import { Input, Select } from '@ddg-frontend/inputs'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router'
import { useLocation, Link } from 'react-router-dom'
import { useApp } from '../app-context'
import { ChannelModal } from '../channels-modal'
import { formatDate, getResource } from '../../utils'
import recordings from '../../assets/recordings.svg'

export const ProgramGridHeader = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { channelData, days, timeline, setDateFromHeader } = useApp()
  const { dateDisplayed } = timeline

  const pathSegments = location.pathname.split('/').filter(Boolean)
  const channelParam = pathSegments[pathSegments.length - 1]
  const channel = channelData?.find((c) => c.callLetter === channelParam)

  const selectOptions = useMemo(
    () =>
      (days ?? []).map((day) => ({
        value: day,
        label: formatDate(new Date(day), new Date()),
      })),
    [days]
  )

  const [searchValue, setSearchValue] = useState('')
  const isSapo = !!import.meta.env.VITE_IS_SAPO
  const language = window.ISites.WegLot?.GetCurrentLanguage() || 'PT'
  return (
    <div className="program-grid-header">
      <div className="program-grid-logo">
        {channel && (
          <img
            src={channel.logoUrl}
            alt={`logo ${channel.title}`}
            loading="lazy"
            height="33"
          />
        )}
      </div>

      <div className="date-picker">
        <Select
          isSearchable={false}
          options={selectOptions}
          value={{
            value: dateDisplayed.toISOString().slice(0, 10),
            label: formatDate(dateDisplayed, new Date()),
          }}
          placeholder={getResource('Grid.Select.Placeholder')}
          onChange={(option) => {
            const day = option?.value
            if (!day) return
            setDateFromHeader(new Date(day))
          }}
        />
      </div>

      <div className="program-grid-right">
        <Input
          label="Pesquisar Programa"
          className="search-input"
          onChange={(e) => setSearchValue(e.currentTarget.value)}
          value={searchValue}
          onClick={() => {
            if (searchValue) {
              navigate(
                `/${
                  language === 'EN' ? 'search-results' : 'pesquisa'
                }?termo=${searchValue}`
              )
            }
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && searchValue.length > 0) {
              navigate(
                `/${
                  language === 'EN' ? 'search-results' : 'pesquisa'
                }?termo=${searchValue}`
              )
            }
          }}
        />
        <div className="program-grid-icons">
          {channel && <ChannelModal />}
          <Link
            to={`/${language === 'EN' ? 'recordings' : 'gravacoes-agendadas'}`}
            className="recording-icon"
            target={isSapo ? '_blank' : undefined}
          >
            <img src={recordings} alt="Gravações" />
            <span className="screen-readers-only">Ver as minhas gravações</span>
          </Link>
        </div>
      </div>
    </div>
  )
}
